import { Component, OnInit } from '@angular/core';

import { User } from '../../../../../common/models/main';
import { ApiService } from '../../../../../common/services/api.service';
import { CacheService } from '../../core/services/cache.service';


@Component({
  selector: 'app-chat-detail',
  templateUrl: './iframe.component.html',
  styleUrls: ['./iframe.component.scss'],
})

export class IframeComponent implements OnInit {
  user!: User;
  url!: string;

  constructor(private cache: CacheService, private api: ApiService) {
  }

  async ngOnInit() {
    this.user = await this.cache.getUserPromise();
    this.cache.getUser().subscribe((user) => this.user = user);

    const powerBi = this.user.organization?.integrations.powerBi;
    if (!powerBi?.enabled) return;

    // Se pide la URL al back, que decide: firma el embed si hay clave común configurada y la url
    // es un dashboard con id numérico; si no, devuelve la url tal cual (retrocompatible con los
    // enlaces públicos ya configurados). Fallback a la url pública si la petición falla.
    if (this.user.organization) {
      this.api.getBiEmbedUrl(this.user.organization.id).subscribe({
        next: (url) => this.url = url,
        error: (err) => {
          console.error('getBiEmbedUrl failed, falling back to public url', err);
          this.url = powerBi.url;
        },
      });
    } else {
      this.url = powerBi.url;
    }
  }
}
